import { type PropsWithChildren, type ReactElement } from 'react'
import { ScrollArea, type ScrollAreaAutosizeProps } from '@mantine/core'
import { cn } from '../../util/tw-merge'

type ScrollAreaProps = {
  containerProps?: ScrollAreaAutosizeProps
  scrollArea: true
}

type Props = PropsWithChildren<{ className?: string; noPadding?: boolean } & (ScrollAreaProps | { scrollArea?: false })>

export const PageContent = ({ children, className, noPadding, ...props }: Props): ReactElement => {
  const paddingClass = noPadding ? 'p-0' : 'px-5xl py-4xl'

  if (props.scrollArea) {
    return (
      <ScrollArea.Autosize
        className='min-h-0 overflow-auto overscroll-contain [scrollbar-gutter:stable]'
        flex={1}
        {...props.containerProps}
      >
        <div className={cn('gap-2xl flex flex-col', paddingClass, className)}>{children}</div>
      </ScrollArea.Autosize>
    )
  }

  return (
    <div className={cn('gap-4xl flex min-h-0 flex-1 flex-col overflow-hidden', paddingClass, className)}>
      {children}
    </div>
  )
}
